export const STATUS_STYLES: Record<string, React.CSSProperties> = {
  "needs attention": { border: "1px solid #E35D6A" , background:"#F8D7DA", color: "#000" },
  "needs attention(pickup overdue)": { border: "1px solid #E35D6A" , background:"#F8D7DA", color: "#000" },
  "on time": { background: "#fff", color: "#000",  },
  "awaiting response": { border: "1px solid #ecd074" , background:"#FFF3CD", color: "#000"  },
  "scan rejected": { background: "#b32e2e", color: "#fff" },
  "design overdue": { background: "#B45309", color: "#fff" },
  "completed": {  border: "1px solid #98e0bf" , background:"#D1E7DD", color: "#000" },
  "waiting for design": { background: "#0d6efd", color: "#fff" },
  "in milling": { background: "#6f42c1", color: "#fff" },
  "assigned": { background: "#20c997", color: "#fff" },
  "acceptance overdue": { background: "#dc3545", color: "#fff" },
  "in design": { background: "#ffcd39", color: "#000" },
};

export const DEFAULT_STATUS_STYLE: React.CSSProperties = { 
  background: "#6c757d", 
  color: "#fff" 
};

export const getStatusStyle = (status: string): React.CSSProperties => {

  return STATUS_STYLES[status?.toLowerCase()] || DEFAULT_STATUS_STYLE;
};